import { Metamodel } from 'app/model/base/model';
import { DataFlowDatasetSettings } from './dataflow-dataset-settings';
import { DataFlowExpression } from '../dataflowexpression';

export enum FILEMODE {
    FILE,
    WILDCARD
}

@Metamodel.model({
    name: 'filebasedsettings'
})
export abstract class FileBasedSettings extends DataFlowDatasetSettings {
    // todo: change to location based later
    public folderPath: DataFlowExpression;
    public container: DataFlowExpression;
    public fileName: DataFlowExpression;
    public fileMode: FILEMODE;

    public initialize(subFormat: string): void {
        this.folderPath = this.transform.createTemplatableExpression();
        this.container = this.transform.createTemplatableExpression();
        this.fileName = this.transform.createTemplatableExpression();
        this.fileMode = FILEMODE.FILE;
    }
}
